export enum PaymentGatewayModel {
    Direct = 'Direct',
    MerchantOfRecord = 'MerchantOfRecord',
    PaymentFacilitator = 'PaymentFacilitator',
}
